package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.AssignTicketResult
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class AssignTicketUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(ticketId: String): AssignTicketResult = repo.assignTicket(ticketId)
}
